export default __webpack_public_path__ + "static/media/logo_ceva.7984f2ab.png";